export default __webpack_public_path__ + "static/web-50d3f98c99d03070676de802dd3fcc3d.png";